<template>
  <material-card-sba
    :size.sync="internalSize"
    :order.sync="internalOrder"
    :height.sync="internalHeight"
    :maxOrderValue="maxOrderValue"
    color="info"
    :widgetIcon="widgetIcon"
    :title="$t('components.vue_material_dashboard.items.events.title')"
  >
    <v-row no-gutters class="fill-height mx-6" justify="end">
      <v-card-text class="text-left pb-0">
        <v-list dense max-height="70" class="hide-scrollbar mt-4 pt-0">
          <div v-show="!loading">
            <v-divider></v-divider>
            <transition name="slide-fade" mode="out-in">
              <v-list-item v-if="currentEvent" :key="'doc-' + currentIndex">
                <v-list-item-icon>
                  <v-icon size="50" color="accent" class="mt-5">{{
                    currentEvent.Icon
                  }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="pl-4">
                  <v-list-item-title @click="goToDocument(currentEvent)">
                    {{ currentEvent.Name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    currentEvent.Venue
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ currentEvent.Location }} -
                    <span class="secondary--text">{{
                      $helpers.formatDate(currentEvent.Date)
                    }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </transition>
            <v-divider></v-divider>
          </div>
        </v-list>
      </v-card-text>
      <v-btn color="info" to="/upcoming-events" class="action-btn">{{
        $t("globals.more")
      }}</v-btn>
      <v-progress-circular
        v-show="loading"
        size="50"
        class="loader"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </material-card-sba>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MaterialCardSba from "@/components/VueMaterialDashboard/material/MaterialCardSbaDashboard.vue";
export default {
  components: {
    MaterialCardSba,
  },
  props: {
    widgetId: String,
    widgetIcon: String,
    size: Number,
    height: Number,
    order: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalOrder: undefined,
      internalHeight: undefined,
      selectedItem: undefined,
      loading: false,
      currentIndex: 0,
      intervalId: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["user", "role"]),
    ...mapGetters("common", ["upcomingEventsData", "userProfile"]),
    currentBenefits() {
      let memberBenefits = this.userProfile?.Coverages.filter(
        (c) => !c.IsWaived
      );
      return memberBenefits.map((c) => c?.CurrentBenefit?.Name);
    },
    latest3Events() {
      const documents = this.upcomingEventsData
        ? JSON.parse(JSON.stringify(this.upcomingEventsData))
        : [];
      const sortedByDate = documents.sort(function (a, b) {
        return new Date(a.Date) - new Date(b.Date);
      });
      // if (this.role === "Trustee")
      //   return sortedByDate
      //     .filter((d) => d.MemberTypes.includes("Trustee"))
      //     .slice(0, 3);
      let filteredItems = sortedByDate.filter((i) => {
        return (
          i.MemberTypes?.includes(this.userProfile.MemberGroup?.Name) ||
          i.MemberTypes?.includes("All")
        );
      });
      // return filteredItems.slice(0, 3);
      return filteredItems;
    },
    currentEvent() {
      return this.latest3Events?.[this.currentIndex] || null;
    },
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    height: {
      handler(v) {
        this.internalHeight = v;
      },
    },
    internalHeight: {
      handler(v) {
        this.$emit("update:height", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
    latest3Events(newVal) {
      if (newVal?.length) {
        this.startAutoScroll();
      }
    },
  },
  mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.height !== null && this.height !== undefined) {
      this.internalHeight = this.height;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
    if (this.latest3Events?.length) {
      this.startAutoScroll();
    }
  },
  methods: {
    ...mapActions("common", ["getDownloadCentreData"]),
    goToDocument(doc) {
      this.$router.push({
        name: "downloadCentre",
        params: {
          doc: doc,
        },
      });
    },
    startAutoScroll() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        if (this.latest3Events.length > 0) {
          this.currentIndex =
            (this.currentIndex + 1) % this.latest3Events.length;
        }
      }, 3000); // Change every 3 seconds
    },
    printFile() {
      console.log("Print file");
    },
    downloadFile() {
      console.log("Download file");
    },
  },
};
</script>
<style scoped>
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.action-btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
}
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
</style>
